module.exports = __webpack_public_path__ + "img/12.ded80b65.jpg";